import styled from 'styled-components/macro';
import { Grid } from '@mui/material';
// import Grid from './Grid';
// import Grid from '@mui/material/Grid';

const FormRow = styled(Grid)`
  margin-bottom: 16px;

  &.with-helpers {
    margin-bottom: -4px;
  }
`;

export default FormRow;
